import { EDruhCp } from 'enums/isin/udaje/druhCp';

export const druhCpSelectJiny = [
    {
        value: EDruhCp.PREDNOSTNIPRAVO, // přednostní právo
        labelcz: 'ISIN_EMISE_DRUH_PREDNOSTNIPRAVO'
    },
    {
        value: EDruhCp.PRAVOUPSANI, // právo upsání
        labelcz: 'ISIN_EMISE_DRUH_PRAVOUPSANI'
    },
    /* {
        value: EDruhCp.ZATIMNILISTY, // zatímní listy
        labelcz: 'ISIN_EMISE_DRUH_ZATIMNILISTY',
    }, */
    {
        value: EDruhCp.OSTATNI, // ostatní
        labelcz: 'ISIN_EMISE_DRUH_OSTATNI'
    }
];
export const druhCpSelect = [
    {
        value: EDruhCp.AKCIE, // akcie
        labelcz: 'ISIN_EMISE_DRUH_AKCIE'
    },
    {
        value: EDruhCp.DLUHOPIS, // dluhopis
        labelcz: 'ISIN_EMISE_DRUH_DLUHOPIS'
    },
    {
        value: EDruhCp.PODILLIST, // list
        labelcz: 'ISIN_EMISE_DRUH_PODILLIST'
    },
    {
        value: EDruhCp.INVCERT, // certifikat
        labelcz: 'ISIN_EMISE_DRUH_INVCERT'
    },
    {
        value: EDruhCp.WARRANT, // warrant
        labelcz: 'ISIN_EMISE_DRUH_WARRANT'
    },
    {
        value: EDruhCp.NASTROJKOLINV, // kolektivni
        labelcz: 'ISIN_EMISE_DRUH_NASTROJKOLINV'
    },
    {
        value: EDruhCp.JINYINVNASTROJ, // jiny
        labelcz: 'ISIN_EMISE_DRUH_JINYINVNASTROJ'
    }
];
export const druhCpSelectDLT = [
    {
        value: EDruhCp.AKCIE, // akcie
        labelcz: 'ISIN_EMISE_DRUH_AKCIE'
    },
    {
        value: EDruhCp.DLUHOPIS, // dluhopis
        labelcz: 'ISIN_EMISE_DRUH_DLUHOPIS'
    }
];

export const druhCpSelectAlt = [
    {
        value: EDruhCp.DLUHOPIS, // dluhopis
        labelcz: 'ISIN_EMISE_DRUH_DLUHOPIS'
    },
    {
        value: EDruhCp.INVCERT, // certifikat
        labelcz: 'ISIN_EMISE_DRUH_INVCERT'
    },
    {
        value: EDruhCp.WARRANT, // warrant
        labelcz: 'ISIN_EMISE_DRUH_WARRANT'
    }
];
